import {
    limpiarInput,
    updateCantidadFromSelect,
    updateCantidadInput,
    changeCantidad,
    changeCantidadMultiSelector,
    handleInputCantidadEvent,
    syncSelectWithInput
} from '../08-views/catalogo/articulos/selector-cantidad';

import {
    articulosConInformacionMinifichaConfirming
} from './articulos-con-informacion-minichicha-confirming';
import {warningAceptarCancelarConfirming} from "./warning-aceptar-cancelar-confirming";

window.limpiarInput                = limpiarInput;
window.updateCantidadFromSelect    = updateCantidadFromSelect;
window.updateCantidadInput         = updateCantidadInput;
window.changeCantidad              = changeCantidad;
window.changeCantidadMultiSelector = changeCantidadMultiSelector;
window.handleInputCantidadEvent    = handleInputCantidadEvent;
window.syncSelectWithInput         = syncSelectWithInput;

$(function () {
    loadCarritosMenu();
});

/*** CARGAR/LISTAR CARRITO ***/

window.carritosMenuLoadingCounter = 0;

function getTiposCarritoMenu(tipos = []) {
    return tipos.length === 0 ? [
        'NOR',
        'AGE',
        'DRO'
    ] : tipos;
}

function toggleEstadoCargaCarritosMenu(tipos = [], isLoading = false) {
    const tiposCarrito = getTiposCarritoMenu(tipos);

    tiposCarrito.forEach((tipo) => {
        const $carrito = $(`#carritoMenu${tipo}`);
        const $dropdown = $(`#carritoMenu${tipo}Dropdown`);

        if (isLoading) {
            $carrito.addClass('disabled')
                .attr('aria-disabled', 'true')
                .css('pointer-events', 'none');
            $dropdown.addClass('disabled')
                .attr('aria-disabled', 'true')
                .css('pointer-events', 'none');
            $carrito.find('.item-number').html(`<i class="ri-loader-4-line spinner" style="display: inline-block"></i>`);
            $carrito.find('.item-quantity').html(`<i class="ri-loader-4-line spinner" style="display: inline-block"></i>`);
            return;
        }

        $carrito.removeClass('disabled')
            .removeAttr('aria-disabled')
            .css('pointer-events', '');
        $dropdown.removeClass('disabled')
            .removeAttr('aria-disabled')
            .css('pointer-events', '');
    });
}

window.startCarritosMenuLoading = function (tipos = []) {
    window.carritosMenuLoadingCounter += 1;
    $('.btn-buy').prop('disabled', true);
    toggleEstadoCargaCarritosMenu(tipos, true);
};

window.stopCarritosMenuLoading = function (tipos = []) {
    window.carritosMenuLoadingCounter = Math.max(0, window.carritosMenuLoadingCounter - 1);

    if (window.carritosMenuLoadingCounter > 0) {
        return;
    }

    $('.btn-buy').prop('disabled', false);
    toggleEstadoCargaCarritosMenu(tipos, false);
};

/**
 * Carga los carritos en el menú
 *
 * @param tipoCarrito {array} Tipos de carritos a cargar
 * @param shouldUpdate {boolean} Bandera para determinar si se deben actualizar los totales de los carritos en sesión
 */
window.loadCarritosMenu = function (tipoCarrito = [], shouldUpdate = false) {
    startCarritosMenuLoading(tipoCarrito);

    return $.ajax({
        url:      urlCarrito + '/get-totales',
        type:     'POST',
        dataType: 'json',
        data:     {
            orderBy:        [
                'tipo_id',
                'titulo',
            ],
            tipo_carrito:   tipoCarrito,
            update_totales: shouldUpdate ? 1 : 0,
        },
    })
     .done(function (response) {
         // Rellenamos los carritos en el menú
         fillCarritosMenu(response);

         // Si estamos en la página de carrito, rellenamos el selector de carritos en el menú de acciones masivas a los que se pueden mover los artículos de la cesta
         if (typeof flagPaginaCarrito != 'undefined' && flagPaginaCarrito === true) {
             fillCarritosMover(response);
         }

     })
     .fail(function (jqXHR, status, error) {
         let errors = '';
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         }
         pNotifyError(errors);
     })
     .always(function () {
         stopCarritosMenuLoading(tipoCarrito);
     });
}

/**
 * Rellena los carritos en el menú con los datos obtenidos del servidor
 *
 * @param carritos {array} Datos de carritos con los que rellenar el menú
 */
let tituloCesta;
window.fillCarritosMenu = function (carritos) {
    // Eliminamos los carritos del menú
    $('#carritoMenuNORDropdownList li').has('button.carritoMenuNORDropdownItem').remove();

    // Recorremos los carritos
    carritos.forEach((carrito, index) => {
        // Establecemos el título del carrito
        tituloCesta = `${transCarritoValores['titulo'][carrito.titulo]}`;
        if (tituloCesta === 'undefined') {
            tituloCesta = carrito.titulo;
        }
        // Si el carrito no está activo y es de tipo NOR, lo añadimos a la lista de carritos NOR. En caso contrario, actualizamos el carrito correspondiente en el menú
        if (!carrito.activo && carrito.tipo_id == 1) {
            $('#carritoMenuNORDropdownList li:has(hr.dropdown-divider)').before(`<li><button class="dropdown-item carritoMenuNORDropdownItem" onclick="changeCarritoNOR(${carrito.id});">${tituloCesta}</button></li>`);
        } else {
            // Determinamos el tipo de carrito
            let cart = '';
            switch (carrito.tipo_id) {
                case 1:
                    cart = 'NOR';
                    break;
                case 2:
                    cart = 'DRO';
                    break;
                case 3:
                    cart = 'AGE';
                    break;
            }

            // Actualizamos el carrito en el menú
            $(`#carritoMenu${cart}`).attr('href', `${urlCarrito}/${carrito.id}`);
            $(`#carritoMenu${cart} h4 span`).text(tituloCesta);
            $(`#carritoMenu${cart} .item-number`).text(carrito.cantidad_total);
            $(`#carritoMenu${cart} .item-number i`).remove();
            $(`#carritoMenu${cart} .item-quantity`).text(number_format(carrito.precio_total) + ' €');
            $(`#carritoMenu${cart} .item-quantity i`).remove();

            // Cambiamos el color del número de artículos si el carrito ha alcanzado el pedido mínimo
            if (carrito.pedido_minimo) {
                $(`#carritoMenu${cart} .item-number`).addClass('bg-success');
            } else {
                $(`#carritoMenu${cart} .item-number`).removeClass('bg-success');
            }

        }
    });
}

/**
 * Actualiza la cantidad y el precio del carrito en el menú
 *
 * @param tipo {string} Tipo de carrito
 * @param accion {string} Acción a realizar, puede ser 'añadir' o 'eliminar'
 * @param articulos {array} Datos de artículos con los que actualizar el carrito
 */
window.updateCarritoMenu = function (tipo = '', accion = '', articulos = []) {
    const $carrito = $(`#carritoMenu${tipo}`);

    let cantidadActualCarrito = parseInt($carrito.find('.item-number').text());
    let precioActualCarrito   = parseFloat($carrito.find('.item-quantity').text().replace('€', '').trim().replace(',', '.'));

    articulos.forEach(({
        cantidad,
        stock,
        cantidadCarrito,
        precio,
        descuento,
        descuento_inline
    }) => {
        // let precioUnitario = precio * (1 - descuento / 100);
        // precioUnitario     = parseFloat(precioUnitario.toFixed(3));
        // precioUnitario     = Math.round(precioUnitario * 100) / 100;
        const descuentoInline = parseInt(descuento_inline, 10);
        const descuentoAplicable = Number.isNaN(descuentoInline) ? descuento : descuentoInline;
        let precioUnitario = Math.round((precio - (precio * descuentoAplicable / 100)) * 100) / 100;
        switch (accion) {
            case 'añadir':
                if (cantidadCarrito >= stock) {
                    cantidadActualCarrito += cantidad;
                } else {
                    let cantidadAAgregar = Math.min(cantidad, stock - cantidadCarrito);
                    cantidadActualCarrito += cantidad;
                    precioActualCarrito += cantidadAAgregar * precioUnitario;
                }
                break;
            case 'eliminar':
                let cantidadAEliminar = Math.min(cantidad, cantidadActualCarrito);
                cantidadActualCarrito -= cantidad;
                precioActualCarrito -= cantidadAEliminar * precioUnitario;
                break;
        }
    });

    cantidadActualCarrito = Math.max(0, cantidadActualCarrito);
    precioActualCarrito   = Math.max(0, precioActualCarrito);

    $carrito.find('.item-number').text(cantidadActualCarrito);
    $carrito.find('.item-quantity').text(`${number_format(precioActualCarrito)} €`);

}

/*** /CARGAR/LISTAR CARRITO ***/

/*** CRUD CARRITO ***/

/**
 * Crea un nuevo carrito
 */
window.createCarrito = function () {
    let createCarritoNotify = $.confirm({
        columnClass:    'col-md-6',
        icon:           'ri-add-fill ri-xxs',
        title:          transAccionCrearCarrito,
        type:           'green',
        content:        `<!-- Alert Error -->
                            <div id="crearCarritoError" class="alert alert-danger my-3" role="alert" style="display: none;">
                                <i class="ri-alert-fill ri-lg align-middle"></i>
                                <span></span>
                            </div>
                            <!-- /Alert Error -->
                            <form id="crearCarritoFormulario">
                                <div>
                                    <!-- Title -->
                                    <label for="crearCarritoFormularioCampoTitulo" class="form-label">
                                        ${transRecursoCamposTitulo}
                                        <span class="required text-danger" aria-required="true">*</span>
                                    </label>
                                    <input type="text" required="true" maxlength="100" class="form-control required" name="titulo" id="crearCarritoFormularioCampoTitulo" placeholder="${transAccionIntroducirCampoTitulo}" aria-required="true" aria-describedby="crearCarritoFormularioCampoTituloFeedback"/>
                                    <div id="crearCarritoFormularioCampoTituloFeedback" class="invalid-feedback"></div>
                                    <!-- Title -->
                                </div>
                            </form>`,
        buttons:        {
            formSubmit: {
                text:     transAccionEnviar,
                btnClass: 'btn btn-success float-end',
                action:   function () {
                    let jc = this;
                    cleanFeedback('crearCarrito', 'crearCarritoFormulario');
                    if (!$('#crearCarritoFormulario')[0].checkValidity()) {
                        $('<input type="submit">')
                            .hide()
                            .appendTo(jc.$content.find('#crearCarritoFormulario'))
                            .click()
                            .remove();
                    } else {
                        let formData = new FormData($('#crearCarritoFormulario')[0]);
                        $.ajax({
                            url:         urlCarrito,
                            type:        'POST',
                            data:        formData,
                            processData: false,
                            contentType: false,
                            beforeSend:  function () {
                                jc.$$formSubmit.prop('disabled', true);
                                jc.$$formSubmit.html(`<i class="ri-loader-4-line spinner"></i> ${transAccionProcesando}`);
                            },
                        })
                         .done(function (response) {
                             // Cerramos el notify
                             createCarritoNotify.close();
                             // Notificamos éxito
                             pNotifySuccess(response.message);
                             // Hacemos el cambio del carrito NOR activo al que acabamos de crear
                             changeCarritoNOR(response.resource.id);
                         })
                         .fail(function (jqXHR, status, error) {
                             showInvalidFeedback(jqXHR, 'crearCarrito', 'crearCarritoFormulario');
                         })
                         .always(function () {
                             jc.$$formSubmit.prop('disabled', false);
                             jc.$$formSubmit.html(transAccionEnviar);
                         });
                    }
                    return false;
                }
            },
            cancel:     {
                text:     transAccionCancelar,
                btnClass: 'btn btn-light float-start',
            },
        },
        onContentReady: function () {
            // bind to events
            let jc = this;
            this.$content.find('#crearCarritoFormularioCampoTitulo').focus();
            this.$content.find('form').on('submit', function (e) {
                // if the user submits the form by pressing enter in the field.
                e.preventDefault();
                jc.$$formSubmit.trigger('click'); // reference the button and click it
            });
        }
    });
}

/**
 * Cambia al carrito NOR especificado
 *
 * @param id {int} ID del carrito NOR al que cambiar
 */
window.changeCarritoNOR = function (id) {
    $.ajax({
        url:      urlCarrito + '/' + id,
        type:     'POST',
        dataType: 'json',
        data:     {},
    })
     .done(function (response) {
         pNotifySuccess(response.message);

         // Obtenemos los elementos del menú
         let $carritoMenu = $('#carritoMenuNOR');
         let $lista       = $("#carritoMenuNORDropdownList");

         // Obtenemos el carrito anteriormente activo y el nuevo carrito activo
         let antiguoCarritoActivo = response.resource[$carritoMenu.attr('href').split('/').pop()];
         let nuevoCarritoActivo   = response.resource[id];

         // Actualizamos el carrito activo en el menú con el nuevo carrito activo
         $carritoMenu.attr('href', `${urlCarrito}/${id}`)
                     .find('h4 span').text(nuevoCarritoActivo.titulo)
                     .end().find('.item-number').text(nuevoCarritoActivo.cantidad)
                     .end().find('.item-quantity').text(`${number_format(nuevoCarritoActivo.precio)} €`);


         // Si el carrito al que se cambia no está en la lista, añadimos el botón, si ya está, actualizamos el botón existente con el carrito que antes estaba activo
         let $btn = $lista.find(`button[onclick="changeCarritoNOR(${id});"]`);
         if ($btn.length === 0) {
             $lista.prepend(`<li>
                                <button class="dropdown-item carritoMenuNORDropdownItem" onclick="changeCarritoNOR(${antiguoCarritoActivo.id});">
                                    ${antiguoCarritoActivo.titulo}
                                </button>
                            </li>`);
         } else {
             $btn.attr('onclick', `changeCarritoNOR(${antiguoCarritoActivo.id});`).text(antiguoCarritoActivo.titulo);
         }

         // Obtenemos los elementos de la lista
         let $header        = $lista.children("li").has("h6.dropdown-header");
         let $divider       = $lista.children("li").has("hr");
         let $newCartButton = $lista.children("li").has("button[onclick='createCarrito();']");

         // Ordenamos los carritos por título
         let $items = $lista.children("li")
                            .has("button[onclick^='changeCarritoNOR']")
                            .sort((a, b) => $(a).text().trim().localeCompare($(b).text().trim()));

         // Reconstruimos la lista
         $lista.empty().append($header, $items, $divider, $newCartButton);

         // Si nos encontramos en la página de carrito, redirigimos a la nueva cesta
         if (typeof flagPaginaCarrito != 'undefined' && flagPaginaCarrito === true) {
             window.location = urlCarrito + '/' + id;
         }

     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         }
         pNotifyError(errors);
     });
}

/*** /CRUD CARRITO ***/

/*** ACCIONES SOBRE ARTÍCULOS ***/

/**
 * Realiza la animación de arrastre del artículo hacia el carrito indicado.
 *
 * @param tipo {string} Tipo de carrito al que se añadió el artículo
 * @param articulo_id {int} ID del artículo que se añadió al carrito
 */
function animateCart(tipo, articulo_id) {
    const product = $(`#product-id-${articulo_id}`).parent(); // Producto
    const cart    = $(`#carritoMenu${tipo}`); // Carrito

    // Clona la imagen del producto y la añade al DOM
    const flyImage = product.clone().css({
        position: 'absolute',
        zIndex:   1000,
        top:      product.offset().top,
        left:     product.offset().left,
        width:    product.width(),
        height:   product.height()
    }).appendTo('body');

    const cartRect    = cart[0].getBoundingClientRect();
    const productRect = product[0].getBoundingClientRect();

    const scale = 0.2; // Factor de escala

    let deltaX = (cartRect.left + window.scrollX - productRect.left - window.scrollX) - (productRect.width * (1 - scale) / 2);
    let deltaY = (cartRect.top + window.scrollY - productRect.top - window.scrollY) - (productRect.height * (1 - scale) / 2);

    // Primera animación: Mueve el clon hacia el carrito con escalado
    gsap.to(flyImage, {
        duration:   1,
        x:          deltaX,
        y:          deltaY,
        scale:      scale, // Escala del clon al 20%
        opacity:    0.1, // Desvanecimiento
        ease:       "power2.inOut",
        onComplete: function () {
            flyImage.remove(); // Elimina el clon al terminar la animación

            // Segunda animación: Aplica un efecto de zoom al carrito
            gsap.to(cart, {
                scale:    1.2, // Tamaño aumentado temporalmente
                duration: 0.3,
                ease:     "power1.inOut",
                yoyo:     true, // Hacer que vuelva a su tamaño original
                repeat:   1 // Solo dos etapas (crece y vuelve)
            });
        }
    });
}

window.checkCondicionesArticulo = async function (
    tipoCarrito      = 'NOR',
    articulo         = [],
    incrementing     = 1,
    mostrarAnimacion = true,
    button           = null
) {
    const articuloInfo    = articulo[Object.keys(articulo)[0]];
    let mostrarConfirming = false;
    let content           = '<ul class="text-start">';

    if (articuloInfo.informacionMinificha !== '') {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transArticulosInfoConfirmar}</strong></p><ul style="margin: 0">`;
        content += `<li>${articuloInfo.ean}: ${articuloInfo.informacionMinificha}</li>`;
        content += `</ul>`;
    }
    if (articuloInfo.comunidadDiferente) {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transArticulosConComunidadDiferente}</strong></p><ul style="margin: 0">`;
        content += `<li>${articuloInfo.ean}</li>`;
        content += `</ul>`;
    }
    if (mostrarConfirming) {
        content += `</ul>`;
        if (!await warningAceptarCancelarConfirming(content)) {
            return false;
        }
    }
    // Si se han superado las condiciones, se procede a añadir el artículo al carrito
    syncArticulosConCarrito(tipoCarrito, articulo, 1, mostrarAnimacion, button);
}
/**
 * Sincroniza los artículos con el carrito especificado
 *
 * @param {string} tipo El tipo de carrito al que se añadirán los artículos
 * @param {array} articulo_id El/los ID del artículo/s a adjuntar
 * @param {int} incrementing Si es true, la cantidad especificada en articulo_id se sumará a la cantidad existente del artículo en el carrito si este existe; si el artículo no existe en el carrito, se creará con la cantidad especificada.
 * @param {boolean} mostrarAnimacion Bandera para determinar si se muestra la animación al añadir al carrito
 * @param {HTMLElement} button Botón que ha activado la acción
 */
window.syncArticulosConCarrito = async function (
    tipo             = 'NOR',
    articulo_id      = [],
    incrementing     = 1,
    mostrarAnimacion = true,
    button           = null
) {
    if (0 === articulo_id.length) {
        return false;
    }
    let mostrarConfirming = false;
    let continuar         = true;
    let articulos         = [];
    let content           = '<ul class="text-start">';
    $.each(articulo_id, function (id, data) {
        if (data.cantidad === 0 || Number.isNaN(data.cantidad)) {
            if ($(`#product-id-${id}`).length) {
                let input    = $(`#product-id-${id} .product-quantity input`);
                let unidades = input.data('unidades');
                if (unidades) {
                    input.val(`1 - ${1 * unidades}`);
                } else {
                    input.val(1);
                }
            }
            data.cantidad = 1;
        }
        // Pre-procesa valores de los campos de artículos a adjuntar en el carrito
        if (data.cantidad === undefined || data.cantidad === null || data.cantidad === '' || data.cantidad < 0) {
            if (!(
                (data.incluido === 0 || data.incluido === 1) ||
                (data.checked === 0 || data.checked === 1) ||
                (data.reservar === 0 || data.reservar === 1) ||
                (Number.isInteger(data.descuento) && data.descuento >= 0) ||
                data.descuento_inline === null ||
                (Number.isInteger(data.descuento_inline) && data.descuento_inline >= 0)
            )) {
                continuar = false;
                return false;
            }
        } else {
            // Pre-procesa artículos a añadir al total del menú del carrito
            if (data.stock === undefined) {
                // Si el stock no está definido, significa que el artículo está descatalogado, por lo que no se añade al total del menú del carrito
                return false;
            }
            const articulo_id = {
                id:              id,
                cantidad:        data.cantidad,
                stock:           data.stock,
                precio:          data.precio,
                descuento:       (isNaN(data.descuentoArticulo) ? 0 : data.descuentoArticulo),
                descuento_inline: data.descuento_inline,
                cantidadCarrito: data.cantidadCarrito || 0,
            };

            articulos.push(articulo_id)
        }
    });

    if (!continuar) {
        // Detiene la función si la bandera es falsa
        return false;
    }

    let originalClass;
    if (button) {
        $(button).prop('disabled', true);
        originalClass = $(button).find('i').attr('class');
        $(button).find('i').attr('class', 'ri-loader-4-line spinner');
    }

    $.ajax({
        url:      urlCarrito + '/' + tipo + '/sync/articulos',
        type:     'post',
        dataType: 'json',
        data:     {
            sync_id:      articulo_id,
            detaching:    0,
            incrementing: incrementing,
        },
    })
     .done(async function (response) {

         const articulosQueSuperanCantidadMaxima = response.resource.articulosQueSuperanCantidadMaxima;
         if (articulosQueSuperanCantidadMaxima.length > 0) {
             mostrarConfirming = true;
             content += `<p style="margin: 0"><strong>${transSuperadaCantidadMaximaArticuloPedir}</strong></p><ul style="margin: 0">`;
             content += articulosQueSuperanCantidadMaxima.map(articulo => `<li>${articulo.ean}: ${transTotalArticulosAnadidos} ${articulo.cantidad_anadida}</li>`).join('');
             content += `</ul>`;
         }
         if (mostrarConfirming) {
             content += `</ul>`;
             if (!await warningAceptarCancelarConfirming(content)) {
                 return false;
             }
         }

         // Animación al añadir al carrito
         if (mostrarAnimacion) {
             animateCart(tipo, Object.keys(articulo_id)[0]);
             // Si se muestra la animación al añadir al carrito y se envía el parámetro button, se realizó un encestado simple
         }

         // Si no nos encontramos en la página de carrito o sí nos encontramos en la página de carrito y se ha modificado la cantidad de un artículo, actualizamos el carrito en el menú
         if (typeof flagPaginaCarrito === 'undefined' || articulos.length > 0) {
             // Por defecto, la acción es añadir
             let accion = 'añadir';

             // Si estamos en la página de carrito, la acción es añadir o eliminar según la nueva cantidad del artículo
             if (typeof flagPaginaCarrito !== 'undefined') {
                 // Si la nueva cantidad del artículo es mayor que la cantidad actual, la acción es añadir, en caso contrario la acción es eliminar
                 if (articulos[0].cantidad > articulos[0].cantidadCarrito) {
                     articulos[0].cantidad = articulos[0].cantidad - articulos[0].cantidadCarrito;
                 } else {
                     accion                = 'eliminar';
                     articulos[0].cantidad = articulos[0].cantidadCarrito - articulos[0].cantidad;
                 }
             } else {
                 // Si no estamos en la página del carrito, tenemos que obtener la cantidad que ya pueda haber de los artículos
                 // en la cesta para que se pueda actualizar el carrito del menú según el stock de los artículos
                 let carrito = response.resource.oldCart.articulos.list;
                 $.each(articulos, function (index, articulo) {
                     const articuloEnCarrito = carrito.find(item => item.id === parseInt(articulo.id));
                     if (articuloEnCarrito) {
                         const articuloConCantidadSuperada = articulosQueSuperanCantidadMaxima.find(item => item.ean === articuloEnCarrito.ean)
                         if (articuloConCantidadSuperada) {
                             articulo.cantidadCarrito = maxCantidadArticuloPedir;
                             articulo.cantidad        = articuloConCantidadSuperada.cantidad_anadida;
                         } else {
                             articulo.cantidadCarrito = articuloEnCarrito.pivot.cantidad;
                         }
                     }
                 });
             }

             pNotifySuccess(response.message);

             // Actualizamos el carrito en el menú
             updateCarritoMenu(tipo, accion, articulos);
         }

         // Colocamos el foco en el input del buscador si se ha añadido un producto a la cesta
         if (typeof flagPaginaCarrito === 'undefined') {
             $('#busquedaMenuFormularioCampoTitulo').focus();
         }
     })
     .fail(function (jqXHR, status, errorThrown) {

         // Si es un error 409, significa que se ha superado el número máximo de artículos en el carrito
         if (jqXHR.status === 409) {
             pNotifyWarning(jqXHR.responseJSON.message);
             return false;
         }

         let errors = '';
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         } else if (errorThrown) {
             errors = errorThrown;
         }
         pNotifyError(errors);
         // para rebocar los cambios se recarga la página
         setTimeout(function () {
             window.location.reload();
         }, 500);


     })
     .always(function () {
         if (button && originalClass !== undefined) {
             $(button).find('i').attr('class', originalClass);
             $(button).prop('disabled', false);
         }
     });
}

/**
 * Comprueba y actualiza la cantidad de un artículo en la minificha
 *
 * @param inputField {HTMLElement} Campo de cantidad
 * @param articulo_id {int} ID del artículo
 *
 * @disclaimer Esta función debería estar en un script exclusivo para el input de cantidad
 */
window.updateCantidad = function (inputField, articulo_id) {

    return updateCantidadInput(inputField, articulo_id);
}

export async function showConfirmingSuperadoCantidadMaximaArticulos(articulosQueSuperanCantidadMaxima) {
    let mostrarConfirming = false;
    let content           = '<ul class="text-start">';
    if (articulosQueSuperanCantidadMaxima.length > 0) {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transSuperadaCantidadMaximaArticuloPedir}</strong></p><ul style="margin: 0">`;
        content += articulosQueSuperanCantidadMaxima.map(articulo => `<li>${articulo.ean}: ${transTotalArticulosAnadidos} ${articulo.cantidad_anadida}</li>`).join('');
        content += `</ul>`;
    }
    if (mostrarConfirming) {
        content += `</ul>`;
        if (!await warningAceptarCancelarConfirming(content)) {
            return false;
        }
    }
}

/*** /ACCIONES SOBRE ARTÍCULOS ***/
